import React, { useState } from 'react'

import pathwaySetTopics from '../../../operations/pathwaySetTopics'
import { Modal } from '../../../components/common/modal/Modal'
import { SearchableItemTypesEnum } from '../../../../../shared/enums/common'
import { ButtonPrimary, ButtonLight } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import { SelectEntitiesForm } from '../../../components/common/selectEntitiesForm'

interface ISelectTopicsModalProps {
  modalProps: {
    header: string
    subHeader: string
    className: string
  }
  onAddTopics: (topicIds: number[]) => void
  onCancel: () => void
  selectedTopicIds: number[]
  pathwayId: number
}

export const SelectTopicsModal = (props: ISelectTopicsModalProps) => {
  const [selectedIds, setSelectedIds] = useState(props.selectedTopicIds)

  return (
    <Modal
      controls={
        <>
          <ButtonLight
            onClick={(): void => {
              setSelectedIds(props.selectedTopicIds)
              props.onCancel()
            }}
          >
            <Trans>Cancel</Trans>
          </ButtonLight>
          <ButtonPrimary
            onClick={async () => {
              const { onAddTopics, pathwayId } = props

              await pathwaySetTopics(pathwayId, selectedIds)
              onAddTopics(selectedIds)
            }}
          >
            <Trans>Add</Trans>
          </ButtonPrimary>
        </>
      }
      {...props.modalProps}
    >
      <SelectEntitiesForm
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        entityType={SearchableItemTypesEnum.topics}
      />
    </Modal>
  )
}
